import { render } from "./ChartWrapper.vue?vue&type=template&id=4fae3497"
import script from "./ChartWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartWrapper.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/containers/widget/components/ChartWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4fae3497"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4fae3497', __exports__)) {
    api.reload('4fae3497', __exports__)
  }
  
  module.hot.accept("./ChartWrapper.vue?vue&type=template&id=4fae3497", () => {
    api.rerender('4fae3497', render)
  })

}


export default __exports__